import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from "@/shared/components/ErrorBoundary";
import { Spin } from 'antd';

// Lazy load views
const LoanDisbursementListView = lazy(() => import('./views/LoanDisbursementListView'));
const LoanDisbursementDetailsView = lazy(() => import('./views/LoanDisbursementDetailsView'));
const DisbursementHistoryView = lazy(() => import('./views/DisbursementHistoryView'));
const LoanViewPage = lazy(() => import('./views/LoanViewPage'));
const LoanDisbursementPage = lazy(() => import('./views/LoanDisbursementPage'));

// Loading fallback component
const LoadingFallback = () => (
  <div className="flex justify-center items-center h-full p-8">
    <Spin size="large" tip="Loading..." />
  </div>
);

export const loanDisbursementRoutes: RouteObject[] = [
  {
    path: '/loans/disbursement',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <LoanDisbursementListView />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/loans/disbursement/:loanId',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <LoanDisbursementDetailsView />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/loans/disbursement/view/:loanId',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <LoanViewPage />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/loans/disbursement/disburse/:loanId',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <LoanDisbursementPage />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/loans/disbursement-history',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <DisbursementHistoryView />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
];
